export default "__VITE_PUBLIC_ASSET__cfc01897__"